import { render, staticRenderFns } from "./AdminMenuList.vue?vue&type=template&id=72e502ec&scoped=true&"
import script from "./AdminMenuList.vue?vue&type=script&lang=js&"
export * from "./AdminMenuList.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuList.vue?vue&type=style&index=0&id=72e502ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e502ec",
  null
  
)

export default component.exports